export abstract class LoginBase {
  constructor(public email?: string, public password?: string) {}

  public toRequest() {
    return {
      email: this.email,
      password: this.password,
    };
  }
}
